<div class="edit-art-modal" *ngIf="slideState === 'in' || slideState === 'out'">
    <!-- Black Screen Overlay -->
    <div class="overlay" (click)="closeModal()"></div>
  
    <!-- Sliding Edit Form -->
  
    <div class="upload-form" [@slideInOut]="slideState">
      <div class="form-header flex justify-between items-center">
        <div class="edit-art-header">
          <h2>Make Payment</h2>
          <button class="close-button" (click)="closeModal()">Close ×</button>
        </div>
      </div>
    
      <form class="flex flex-col">
        <div class="input-details-container flex flex-col">
          <div class="first-row flex items-start">
            <div class="image-preview relative">
              <app-canvas-preview [drawData]="art"></app-canvas-preview>
            </div>
            <p  style="margin-left: 1rem;text-align: left;
              max-width: 15ch;
              overflow: hidden;
              text-overflow: ellipsis;">
                by {{art?.artistName}}
            </p>

            <p style="margin-left: auto;">
              ${{ (art?.price || art?.artPrice) | number:"1.2-2"}}
            </p>
          </div>
        </div>

        <div class="form-actions flex items-center gap-2">
          <div class="flex flex-col">
            <p class="totalPay">
              Total Payable
            </p>
            <p class="totalAmount">
              ${{(art?.price || art?.artPrice) | number:"1.2-2"}}
            </p>
          </div>
            <app-button text="Pay" (onClick)="openConfirmationPopup()"></app-button>
            <a class="upload pointer" id="myLink" [href]="paymentLink" target="_self"></a>
        </div>

      </form>
    </div>
    
  </div>
  